import { Box, Typography, Link, Divider, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const notifications = [
  {
    date: "01.09.2025",
    title:
      "Revised Office Memorandum of modalities for taking up eco-restoration...",
    link: "https://ankurykftgupta.s3.cyfuture.cloud/gcc/dev/mo-efcc-om-dt-01-09-2025-gcp-revised-modalities-cmf1crzuo00080iymd7u99j66.pdf",
  },
  {
    date: "29.08.2025",
    title:
      "Revised gazette notification of methodology for calculation and issuance of green credits...",
    link: "https://ankurykftgupta.s3.cyfuture.cloud/gcc/dev/265796-cmf1ct68q000a0iym4th8fkn1.pdf",
  },
  {
    date: "22.02.2023",
    title: "Office memorandum of modality for taking up Tree Plantation...",
    link: "https://ankurykftgupta.s3.cyfuture.cloud/gcc/dev/om-for-modality-for-taking-up-tree-plantation-under-green-credit-programme-cmcxajrp600000px15pb66wz2.pdf",
  },
  {
    date: "22.02.2023",
    title:
      "Gazette notification of methodology for calculation of Green Credit...",
    link: "https://ankurykftgupta.s3.cyfuture.cloud/gcc/dev/green-credit-program-notification-closdct3600050pzj8wdrcth8.pdf",
  },
  {
    date: "12.10.2022",
    title: "Green Credit Rules, 2023",
    link: "https://ankurykftgupta.s3.cyfuture.cloud/gcc/dev/green-credit-program-notification-closdct3600050pzj8wdrcth8.pdf",
  },
];

const EntityNotification = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        maxWidth: 1500,
        mx: "auto",
        mt: 6,
        p: isMobile ? 2 : 4,
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <Typography
        variant={isMobile ? "h6" : "h5"}
        fontWeight="bold"
        mb={3}
        color="primary"
        textAlign="center"
      >
        Notifications
      </Typography>

      {notifications.map((item, index) => (
        <Box key={index}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1.5,
              flexDirection: isMobile ? "column" : "row",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: isMobile ? "0.9rem" : "1rem",
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  color: "text.disabled",
                  mr: 2,
                }}
              >
                {item.date}
              </Typography>
              {item.title}
            </Typography>

            <Link
              href={item.link}
              underline="hover"
              sx={{
                fontWeight: 500,
                color: "#00695c",
                mt: isMobile ? 1 : 0,
                "&:hover": { color: "#004d40" },
              }}
            >
              Download
            </Link>
          </Box>

          {index !== notifications.length - 1 && (
            <Divider sx={{ borderColor: "#c8e6c9" }} />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default EntityNotification;
